import * as React from 'react';
import {FormControlLabel, styled} from "@mui/material";

export const BlackDisabledFormControlLabel = styled(FormControlLabel)({
    "& .Mui-disabled": { WebkitTextFillColor: "#656565",color: "#656565" },
});
